module.exports = __webpack_public_path__ + "img/applestore.bb95c469.png";